<template>
  <v-menu
    v-model="menu"
    :close-on-content-click="false"
    :nudge-left="40"
    lazy
    transition="scale-transition"
    max-width="290px"
    offset-y
    full-width
  >
    <v-text-field
      slot="activator"
      :class="{'danger-input' : theme==='dark' , 'general-input' : theme==='light'}"
      :value="displayValue"
      :label="label"
      prepend-icon="event"
      readonly
    />
    <v-card flat>
      <v-date-picker
        v-model="innerDate"
        :min="minDate"
        :max="maxDate"
        :color="theme==='dark'?'danger':'general'"
        type="date"
        no-title
        scrollable
        full-width
      />
      <v-time-picker
        v-model="innerTime"
        :color="theme==='dark'?'error':'general'"
        :use-seconds="true"
        format="24hr"
        type="time"
        full-width
      />
      <v-card-actions>
        <v-spacer />
        <v-btn
          flat
          small
          @click="cancel">
          取消
        </v-btn>
        <v-btn
          color="general"
          flat
          small
          @click="confirm">
          確定
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-menu>
</template>

<script>
import { mapState } from 'vuex'

export default {
  name: 'DatetimeField',
  props: {
    value: {
      type: String,
      default: ''
    },
    label: {
      type: String,
      default: ''
    },
    minDate: {
      type: String,
      default: '2018-04-01'
    },
    maxDate: {
      type: String,
      default: () => new Date().toISOString().substr(0, 10)
    }
  },
  data () {
    return {
      menu: false,
      innerDate: '',
      innerTime: ''
    }
  },
  computed: {
    ...mapState('app', ['theme']),
    displayValue () {
      if (!this.value) return ''
      return this.$moment(this.value, 'YYYY-MM-DD HH:mm:ss').format('YYYY-MM-DD HH:mm:ss')
    }
  },
  watch: {
    value: {
      immediate: true,
      handler (val) {
        this.syncFromValue(val)
      }
    },
    menu (val) {
      if (val) {
        this.syncFromValue(this.value)
      }
    }
  },
  methods: {
    syncFromValue (val) {
      if (val) {
        const m = this.$moment(val, 'YYYY-MM-DD HH:mm:ss')
        this.innerDate = m.format('YYYY-MM-DD')
        this.innerTime = m.format('HH:mm:ss')
      } else {
        this.innerDate = this.$moment(new Date()).format('YYYY-MM-DD')
        this.innerTime = this.$moment(new Date()).format('HH:mm:ss')
      }
    },
    cancel () {
      this.menu = false
      this.syncFromValue(this.value)
    },
    confirm () {
      if (!this.innerDate || !this.innerTime) {
        return
      }
      const time = this.innerTime.length === 5 ? `${this.innerTime}:00` : this.innerTime
      const formatted = this.$moment(`${this.innerDate} ${time}`, 'YYYY-MM-DD HH:mm:ss').format('YYYY-MM-DD HH:mm:ss')
      this.$emit('input', formatted)
      this.menu = false
    }
  }
}
</script>
